import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgFor, NgClass, DecimalPipe } from '@angular/common';


@Component({
    selector: 'app-custom-time-field',
    templateUrl: './custom-time-field.component.html',
    styleUrls: ['./custom-time-field.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgClass,
        ExtendedModule,
        DecimalPipe,
    ],
})
export class CustomTimeFieldComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {}


    @Input() availableFrom: Date;
    @Input() availableTo: Date;
    @Input() form:  UntypedFormControl

    hours = [];
    minutes = [];

    ngOnInit() {
        this.initTime();
    }

    get timeValue(): Date { return this.form.value || new Date() as Date;}

    initTime = () => {
        this.hours = [];
        this.minutes = [];
        for (let index = 1; index <= 23; index++) this.hours.push(index);
        for (let index = 0; index < 60; index++) if (index%30==0) this.minutes.push(index);
    }


    hourChanged(val) {
        this.timeValue.setHours(val);
        this.form.setValue(this.timeValue);
    }


    minuteChanged(val) {
        this.timeValue.setMinutes(val);
        this.form.setValue(this.timeValue);
    }

    hourFilter(hour) {
        let newStart = _.cloneDeep(this.timeValue);
        newStart.setHours(hour);
        return newStart < this.availableFrom || newStart > this.availableTo ;
    }

    minuteFilter(minute) {
        let newStart = _.cloneDeep(this.timeValue);
        newStart.setMinutes(minute);
        return newStart < this.availableFrom || newStart > this.availableTo ;
    }

    checkSelectedHour(val) {
        return this.timeValue.getHours() == val;
    }

    checkSelecteMinuted(val) {
        return this.timeValue.getMinutes() == val;
    }
}
